import { render, staticRenderFns } from "./SettingsParcelas.vue?vue&type=template&id=34711679&scoped=true&"
import script from "./SettingsParcelas.vue?vue&type=script&lang=js&"
export * from "./SettingsParcelas.vue?vue&type=script&lang=js&"
import style0 from "./SettingsParcelas.vue?vue&type=style&index=0&id=34711679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34711679",
  null
  
)

export default component.exports